import { hasAccessBySystemRole } from './hasAccessBySystemRole';
import { orgHasAccess } from './orgHasAccess';
import { userHasAccess } from './userHasAccess';
export const checkPermissions = (userState, ownerId, permissionType, permissions) => {
    return !!(ownerId === userState.id ||
        (permissions &&
            (userHasAccess(userState, permissions, permissionType) ||
                orgHasAccess(userState, permissions, permissionType) ||
                hasAccessBySystemRole(userState, permissions, permissionType))));
};
